__turbopack_context__.v({
  "email": "tf43CW_email",
  "fields": "tf43CW_fields",
  "message": "tf43CW_message",
  "submit": "tf43CW_submit",
});
